export { default } from './AppAuthed.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/AppAuthed/index.js